<!-- @format -->

<div class="custom-section card add-unit">
	<div class="section-header">
		<div>
			<h1 class="section-title">User</h1>

			<span class="subtext">Manage the list of users </span>
		</div>

			<div class="search-bar">
				<img class="search-icon" src="../assets/search-alt.svg" alt="search" />
				<input type="text" (ngModelChange)="onSearchChange($event)" [ngModel]="searchInput" />
			</div>

		<div style=" position: relative;">
		
			<button
				class="botton-container"
				type="button"
				(click)="toggleAdd()">
				Add New
				<img src="../../../assets/down-arrow.svg" width="16px" height="16px" alt="down-arrow" />
			</button>
			<div *ngIf="showAddMenu" class="dropdown-menu">
				<span [ngClass]="{								
						'd-none': currentRole == Roles.admin,
						'button-item': true
					}" *ngIf="currentRole === Roles.superAdmin" [routerLink]="['add-super-user']" [state]="{
						company: selectedCompany,
						plant: selectedPlant
					}">Super Admin</span>
				<a *ngIf="currentRole !== Roles.admin" class="button-item"
					[ngClass]="!activateSubmitBtn() ? 'disabled-link' : ''" [routerLink]="
						activateSubmitBtn() ? ['add-admin-user'] : null
					" [state]="{
						company: selectedCompany,
						plant: selectedPlant
					}">Admin</a>
				<!-- [routerLink]="activateSubmitBtn() ? ['add-admin-user'] : null" -->
				<a [ngClass]="!activateSubmitBtn() ? 'disabled-link' : ''" class="button-item" [routerLink]="
						activateSubmitBtn() ? ['add-non-admin-user'] : null
					" [state]="[selectedCompany, selectedPlant]">
					Non Admin
				</a>
				<a [ngClass]="!activateSubmitBtn() ? 'disabled-link' : ''" class="button-item" [routerLink]="
						activateSubmitBtn() ? ['add-temp-user'] : null
					" [state]="[selectedCompany, selectedPlant]">
					Temp User
				</a>
			</div>
		</div>
	</div>
	<!-- DROPDOWNS -->
	<div class="dropdown-group">
		<app-dropdown *ngIf="currentRole === Roles.superAdmin" [disabled]="false" [options]="companies"
			selectedItem="{{ selectedCompany }}" (onSelectOption)="retrievePlantsByCompanyId($event)"
			[fields]="['companyId', 'companyName']" [label]="
				selectedCompany.companyId === 0
					? 'Choose Account Holder'
					: selectedCompany.companyName
			"></app-dropdown>
		<app-dropdown [disabled]="
				currentRole === Roles.superAdmin && selectedCompany.companyId === 0
					? true
					: false
			" [options]="plants" selectedItem="{{ selectedPlant }}" (onSelectOption)="retrieveUnitsByPlantId($event)"
			[fields]="['plantId', 'plantName']" [ngStyle]="currentRole === Roles.admin ? specialStyle : null" [label]="
				resetPlant || selectedPlant.plantId == 0
					? 'Choose Client'
					: selectedPlant.plantName
			"></app-dropdown>


		<!-- Types of Users -->
		<app-dropdown [disabled]="
				selectedPlant.plantId === 0
					? true
					: false
			" [options]="userTypes" selectedItem="{{ selectedUserType }}" (onSelectOption)="handleSystemType($event)"
			[fields]="['id', 'type']" [ngStyle]="currentRole === Roles.admin ? specialStyle : null" [label]="selectedUserType.id == 0
					? 'Select Type of User'
					: selectedUserType.type
			"></app-dropdown>

		<app-dropdown *ngIf="selectedUserType.id === 1 && selectedPlant.plantId !== 0" [disabled]="
					selectedPlant.plantId === 0
						? true
						: false
			" [options]="userRoleOptions" selectedItem="{{ selectedUserRole }}" (onSelectOption)="handleUserRole($event)"
			[fields]="['id', 'role']" [ngStyle]="currentRole === Roles.admin ? specialStyle : null" [label]="selectedUserRole.id === 0
					? 'All User Roles'
					: selectedUserRole.role
			"></app-dropdown>
	</div>

	<table class="custom-table">
		<thead>
			<tr>
				<th>User</th>
				<th>Group</th>
				<th>Status</th>
				<th></th>
			</tr>
		</thead>
		<tbody *ngFor="let data of usersToDisplay; let rowIndex = index">
			<tr>
				<td>
					<div>
						<p class="title custom-title">
							{{ data.firstName }} {{ data.lastName }}
						</p>
						<div class="roles">
							<span [style]="getRoleColor(data.role)" class="role-container">{{
								this.selectedUserType.id==1 ? data.role : "Temp" }}</span>
							<p class="description custom-title">
								<span class="email-container">{{
									data.email
									}}</span>
							</p>
						</div>
					</div>
				</td>
				<td>
					{{this.selectedUserType.id == 1 ? (data?.group?.[0]?.isDeleted ? "" : data?.group?.[0]?.groupName): (data?.tempUserGroup?.isDeleted ? "" : data?.tempUserGroup?.groupName)}}
				</td>
				<td>{{ this.selectedUserType.id == 1 ? (data.isLocked ? "Locked" : data.isDeleted ? "Inactive" : "Active") : (!data.isDeleted ? "Active" : "Inactive")}}</td>
				<td>
					<img [ngClass]="{
							'd-none':
								(data.role == Roles.superAdmin ||
									data.role == Roles.admin) &&
								currentRole == Roles.admin
						}" *ngIf="!data.isDeleted" src="../../assets/dotted-menu.svg" alt="menu icon" (click)="toggleMenu(data, rowIndex)"
						style="cursor: pointer" />
					<div [ngClass]="{
							'd-none': !isUserMenuOpen(data, rowIndex)
						}" class="custom-table__menu">
						<div class="custom-title">
							{{ data.firstName }} {{ data.lastName }}
						</div>

						<a *ngIf="canEditUser(data)" (click)="
								transferData(
									data, data.role
								)
							">
							<img src="../../assets/edit-pencil.svg" alt="menu icon" />
							<span>Edit User</span>
						</a>
						<div class="underline" [ngClass]="{'title-margin': data.role === Roles.superAdmin}"></div>
						<div [ngStyle]="{
								opacity:
									data.role === Roles.superAdmin &&
									currentRole === Roles.admin
										? '0.5'
										: null,
								cursor:
									data.role === Roles.superAdmin &&
									currentRole === Roles.admin
										? 'not-allowed'
										: 'pointer'
							}" (click)="
								showDeactivateModal(
									data.firstName,
									data.lastName,
									data.role? data.role : 'Temporary User',
									data.email
								)
							">
							<img src="../../assets/delete.svg" alt="menu icon" />
							<span>Deactivate</span>
						</div>
					</div>
				</td>
			</tr>
		</tbody>
	</table>

	<div class="center" *ngIf="currentRole === Roles.superAdmin && selectedCompany.companyId === 0">
		<app-empty-state [data]="emptyStateCompanies" />
	</div>

	<div class="center" *ngIf="showPlantEmptyState()">
		<app-empty-state [data]="emptyStatePlants" />
	</div>

	<div class="center" *ngIf="
			selectedPlant.plantId > 0 &&
			selectedCompany.companyId > 0 &&
			usersToDisplay.length === 0
		">
		<app-empty-state [data]="emptyStateDataPoints" />
	</div>
	<div class="pagination" *ngIf="usersToDisplay.length !== 0">
		<button [style.opacity]="currentPage === 1 ? 0.5 : 1" type="button" (click)="performDecrement()">
			<img class="arrow flipped" src="../../assets/triangle-icon.svg" alt="navigate back" />
		</button>
		<div *ngFor="let item of loopArray; let i = index">
			<button *ngIf="item <= totalPages" [style]="currentPage === item ? selectedPage : ''"
				(click)="setCurrentPage(item)" class="page-number">
				{{ item }}
			</button>
		</div>
		<button [style.opacity]="currentPage === totalPages ? 0.5 : 1" type="button" (click)="performIncrement()">
			<img class="arrow" src="../../assets/triangle-icon.svg" alt="navigate forward" />
		</button>
	</div>
</div>

<app-success-toast *ngIf="toastService.showToast"></app-success-toast>
<app-deactivate-modal (onCancel)="showDeactivateMenu = false" *ngIf="showDeactivateMenu" [title]="deactivateText.title"
	[message1]="deactivateText.message1" [message2]="deactivateText.message2" (onSave)="handleDeactivate(this.deactivationRole)" />
